export interface IReasonsState {
    reasons: any[];
    selectedReason: any;
  }
  
  export const initialReasonsState: IReasonsState = {
    reasons: [],
    selectedReason: null
  };